module.exports = __webpack_public_path__ + "img/prices_en.fd7f7ae1.svg";